export const de = {
  main: {
    color_hex: 'Farbe in hexadezimaler Schreibweise, beginne mit #',
    language: 'Deutsch',
    restricted_field_name: 'Dieser Feldname ist reserviert und kann nicht verwendet werden',
    asset_type_required: 'Wählen Sie mindestens einen Asset-Typ aus oder machen Sie das Feld global',
    searchbar: 'Suchen (min. 3 Zeichen)',
    title: 'Admin',
    logout: 'Abmelden',
    english: 'Englisch',
    dutch: 'Niederländisch',
    french: 'Französisch',
    spanish: 'Spanisch',
    danish: 'Dänisch',
    italian: 'Italienisch',
    romanian: 'Rumänisch',
    norwegian: 'Norwegisch',
    german: 'Deutsch',
    drop_image: 'Bild hier ablegen',
  },
  ra: {
    tree: {
      add_child_node: 'Unterkategorie hinzufügen',
      add_node_after: 'Kategorie danach hinzufügen',
      add_node_before: 'Kategorie davor hinzufügen',
      close: 'Schließen',
      expand: 'Öffnen',
    },
  },
  resources: {
    categories: {
      name: 'Kategorie |||| Kategorien',
      fields: {
        name: 'Kategoriename',
      },
    },
    users: {
      name: 'Benutzer |||| Benutzer',
      fields: {
        category: 'Kategorie',
        connection: 'Verbindung',
        email: 'E-Mail',
        familyName: 'Nachname',
        firstName: 'Vorname',
        language: 'Sprache',
        userRoles: 'Rollen',
      },
    },
    priorities: {
      name: 'Priorität |||| Prioritäten',
    },
    branding: {
      name: 'Branding',
    },
    invitations: {
      name: 'Einladung |||| Einladungen',
      fields: {
        email: 'E-Mail',
      },
    },
    'asset-types': {
      name: 'Asset-Typ |||| Asset-Typen',
      fields: {
        name: 'Name',
      },
    },
    'asset-statuses': {
      name: 'Asset-Status |||| Asset-Status',
      fields: {
        name: 'Name',
      },
    },
    'asset-custom-fields': {
      name: 'Benutzerdefiniertes Asset-Feld |||| Benutzerdefinierte Asset-Felder',
      fields: {
        name: 'Name',
        globalField: 'Global (alle Asset-Typen)',
        assetTypeIds: 'Asset-Typen',
      },
    },
  },
}
